import { useSelector } from 'react-redux'

export default function useUpgradePlanUrl() {
    const userId = useSelector(
        ({ app: { current_user: { id } = {} } = {} }) => id
    )
    
    return `/ratesmgr/profiles/${userId}/edit?section=billing`
}
